module.exports = __webpack_public_path__ + "f1ee2bc2ca6c014cb7ace7115567595f.fbx";